/* Halftime — drapeaux exacts, partout dans le mode rétro.
   · Les drapeaux viennent de « flag-icons » (dessins officiels de chaque pays, version figée 7.2.3, servie par jsDelivr) :
     plus de drapeaux approximatifs dessinés à la main.
   · Angleterre, Écosse, Pays de Galles et Irlande du Nord ont leur propre drapeau (croix de Saint-Georges, sautoir, dragon,
     bannière d'Ulster) ; Kosovo = xk. URSS, RDA et Yougoslavie (pays disparus) sont dessinés ici, d'après leurs vrais drapeaux.
   · Sélection d'équipe (lot 2) : drapeau réel, réduit en pixels pour garder le style rétro (repli : le dessin net si besoin).
   · Tirs au but : les supporters agitent le vrai drapeau de la sélection ; pour un club, une bannière à ses couleurs.
     Le tableau d'affichage montre le drapeau à côté du nom des sélections.
   · HTFlag.code(iso ou nom), HTFlag.url(code), HTFlag.html(code, classe), HTFlag.draw(ctx, équipe, x, y, l, h, vague). */
(function () {
  'use strict';
  if (window.HTFlag) return;
  var CDN = 'https://cdn.jsdelivr.net/npm/flag-icons@7.2.3/flags/4x3/';
  // codes maison du site → codes des fichiers de drapeaux
  var ALIAS = { eng: 'gb-eng', en: 'gb-eng', sco: 'gb-sct', wal: 'gb-wls', nir: 'gb-nir', kos: 'xk', uk: 'gb' };
  // pays disparus : dessins d'après les drapeaux officiels (format 4:3, 640 × 480)
  function svg(b) { return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 480">' + b + '</svg>'); }
  var HIST = {
    // URSS : fond rouge, étoile cerclée d'or, faucille et marteau dorés
    su: svg('<rect width="640" height="480" fill="#CC0000"/><path d="M118.0 26.0L124.2 43.5L142.7 44.0L128.0 55.2L133.3 73.0L118.0 62.5L102.7 73.0L108.0 55.2L93.3 44.0L111.8 43.5Z" fill="none" stroke="#FFD700" stroke-width="4"/>' +
      '<path d="M86 96a46 46 0 1 0 64 -6a38 38 0 1 1 -64 6z" fill="#FFD700"/><path d="M98 160l50-50 10 10-50 50z" fill="#FFD700"/><path d="M80 154l14 14-10 10-14-14z" fill="#FFD700"/><path d="M142 92l18-6 8 8-6 18z" fill="#FFD700"/>'),
    // RDA : noir, rouge, or, avec l'emblème (marteau et compas dans une couronne d'épis)
    ddr: svg('<rect width="640" height="160" fill="#000"/><rect y="160" width="640" height="160" fill="#DD0000"/><rect y="320" width="640" height="160" fill="#FFCE00"/>' +
      '<circle cx="320" cy="240" r="98" fill="#DD0000"/><circle cx="320" cy="240" r="98" fill="none" stroke="#FFCE00" stroke-width="24" stroke-dasharray="14 6"/>' +
      '<path d="M320 170l-46 120h18l28-76 28 76h18z" fill="#FFCE00"/><rect x="262" y="228" width="116" height="12" fill="#FFCE00"/><rect x="300" y="170" width="40" height="22" fill="#FFCE00"/><rect x="314" y="190" width="12" height="70" fill="#FFCE00"/>' +
      '<path d="M250 318h140l-20 22H270z" fill="#000"/>'),
    // Yougoslavie (1945-1992) : bleu, blanc, rouge, étoile rouge bordée d'or
    yu: svg('<rect width="640" height="160" fill="#003893"/><rect y="160" width="640" height="160" fill="#fff"/><rect y="320" width="640" height="160" fill="#DE0000"/>' +
      '<path d="M320.0 122.0L347.6 202.0L432.2 203.5L364.7 254.5L389.4 335.5L320.0 287.0L250.6 335.5L275.3 254.5L207.8 203.5L292.4 202.0Z" fill="#FCD116"/>' +
      '<path d="M320.0 136.0L344.1 206.8L418.9 207.9L359.0 252.7L381.1 324.1L320.0 281.0L258.9 324.1L281.0 252.7L221.1 207.9L295.9 206.8Z" fill="#DE0000"/>')
  };
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  // noms de sélections (français) → code pays ; complété par la liste de la Box Mystère (HTED.NATIONS)
  var NAMES = null;
  var EXTRA = { 'bresil': 'br', 'argentine': 'ar', 'allemagne': 'de', 'italie': 'it', 'espagne': 'es', 'pays bas': 'nl', 'hollande': 'nl', 'angleterre': 'eng', 'portugal': 'pt', 'uruguay': 'uy', 'belgique': 'be',
    'croatie': 'hr', 'mexique': 'mx', 'japon': 'jp', 'cameroun': 'cm', 'france': 'fr', 'ecosse': 'sco', 'pays de galles': 'wal', 'irlande du nord': 'nir', 'urss': 'su', 'rda': 'ddr', 'yougoslavie': 'yu', 'kosovo': 'kos',
    'etats unis': 'us', 'usa': 'us', 'maroc': 'ma', 'senegal': 'sn', 'nigeria': 'ng', 'cote d ivoire': 'ci', 'algerie': 'dz', 'tunisie': 'tn', 'colombie': 'co', 'chili': 'cl', 'suede': 'se', 'danemark': 'dk', 'norvege': 'no',
    'suisse': 'ch', 'autriche': 'at', 'pologne': 'pl', 'tchequie': 'cz', 'republique tcheque': 'cz', 'russie': 'ru', 'ukraine': 'ua', 'turquie': 'tr', 'grece': 'gr', 'serbie': 'rs', 'irlande': 'ie', 'coree du sud': 'kr', 'australie': 'au' };
  function names() {
    if (NAMES) return NAMES;
    var m = {}; Object.keys(EXTRA).forEach(function (k) { m[k] = EXTRA[k]; });
    ((window.HTED && HTED.NATIONS) || []).forEach(function (n) { if (n[4]) m[norm(n[0])] = n[4]; });
    if (window.HTED && HTED.NATIONS) NAMES = m;
    return m;
  }
  // code d'un pays à partir d'un code (fr, eng…) ou d'un nom de sélection (« Brésil »)
  function code(x) {
    if (!x) return '';
    var s = String(x);
    if (/^[a-z]{2,3}(-[a-z]{2,3})?$/.test(s)) return ALIAS[s] || s;
    var c = names()[norm(s)]; return c ? (ALIAS[c] || c) : '';
  }
  function url(c) { c = code(c); if (!c) return ''; return HIST[c] || CDN + c + '.svg'; }
  function esc(s) { return String(s).replace(/"/g, '&quot;'); }
  // <img> du drapeau ; data-htf : réduit en pixels une fois chargé (mode rétro)
  function html(c, cls) {
    var u = url(c); if (!u) return '';
    return '<img class="' + (cls || 'htf') + ' htf-img" src="' + esc(u) + '" alt="" width="40" height="30" loading="lazy" decoding="async" crossorigin="anonymous" data-htf="' + esc(code(c)) + '">';
  }

  /* ---------- version pixel : le vrai drapeau réduit à 32 × 24 pixels puis agrandi sans lissage ---------- */
  var PX = {};
  function pixel(img) {
    if (img.__htf || !img.complete || !img.naturalWidth) return; img.__htf = 1;
    var k = img.getAttribute('data-htf');
    if (PX[k]) { img.src = PX[k]; img.classList.add('htf-px'); return; }
    try {
      var c = document.createElement('canvas'); c.width = 32; c.height = 24; var x = c.getContext('2d');
      x.imageSmoothingEnabled = true; x.drawImage(img, 0, 0, 32, 24);
      PX[k] = c.toDataURL('image/png'); img.src = PX[k]; img.classList.add('htf-px');
    } catch (e) { /* image non lisible : on garde le dessin net */ }
  }
  function scan(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('img.htf-img:not(.htf-px)'), function (img) {
      if (img.complete) pixel(img); else img.addEventListener('load', function () { pixel(img); }, { once: true });
    });
  }

  /* ---------- tirs au but : drapeaux des supporters ---------- */
  var CACHE = {};
  function raster(c) {
    if (CACHE[c] !== undefined) return CACHE[c];
    CACHE[c] = null; var u = url(c); if (!u) return null;
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onload = function () { try { var cv = document.createElement('canvas'); cv.width = 48; cv.height = 36; cv.getContext('2d').drawImage(im, 0, 0, 48, 36); CACHE[c] = cv; } catch (e) { CACHE[c] = im; } };
    im.src = u; return null;
  }
  function isNation(t) {
    if (!t) return '';
    if (t.iso && (t.g === 'nat' || t.z === 'nat')) return code(t.iso);
    var c = code(t.name); if (c && (t.g === 'nat' || t.g == null || t.z === 'nat')) return c;
    return '';
  }
  // dessine le drapeau d'une équipe (3 tranches qui ondulent) ; renvoie true si c'est fait
  function draw(ctx, t, x, y, w, h, wave) {
    if (!t) return false;
    var c = isNation(t);
    if (c) {
      var cv = raster(c); if (!cv) return false;
      var sw = cv.width / 3;
      for (var k = 0; k < 3; k++) ctx.drawImage(cv, k * sw, 0, sw, cv.height, x + k * w / 3, y + (wave || 0) * (k / 3), w / 3 + 1, h);
      return true;
    }
    // club : bannière à ses couleurs (fond couleur 1, bande centrale couleur 2)
    var c1 = t.c1 || '#023270', c2 = t.c2 || '#ffffff';
    for (var j = 0; j < 3; j++) {
      var dy = (wave || 0) * (j / 3);
      ctx.fillStyle = c1; ctx.fillRect(x + j * w / 3, y + dy, w / 3 + 1, h);
      ctx.fillStyle = c2; ctx.fillRect(x + j * w / 3, y + dy + h * .36, w / 3 + 1, h * .28);
    }
    return true;
  }
  // précharge les drapeaux d'un tournoi
  function preload(o) {
    o = o || {};
    [o.club].concat(o.pool || []).forEach(function (t) { var c = isNation(t); if (c) raster(c); });
    ['br', 'ar', 'de', 'it', 'es', 'nl', 'gb-eng', 'pt', 'uy', 'be', 'hr', 'mx', 'jp', 'cm', 'fr'].forEach(raster);
  }
  // couleurs d'équipes du jeu corrigées d'après leur écusson
  var FIXC = { Liverpool: ['#C8102E', '#ffffff'] };
  function fix(o) {
    if (!o) return;
    [o.club].concat(o.pool || []).forEach(function (t) { var f = t && FIXC[t.name]; if (f) { t.c1 = f[0]; t.c2 = f[1]; } });
  }
  function wrapCup() {
    var C = window.VJCup; if (!C || C.__htf) return;
    var W = function (host, o) { try { fix(o); preload(o); } catch (e) {} return C.apply(this, arguments); };
    Object.keys(C).forEach(function (k) { W[k] = C[k]; }); W.__htf = 1; window.VJCup = W;
  }
  // tableau d'affichage : pastille → drapeau pour les sélections
  function board(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.vjc-sb .t, .vjc-vs > *'), function (s) {
      var chip = s.querySelector('.vjc-chip'); if (!chip || chip.__htf) return;
      var c = code(s.textContent.trim()); if (!c) return;
      chip.__htf = 1; chip.classList.add('htf-chip'); chip.style.backgroundImage = 'url("' + url(c) + '")';
    });
  }

  /* ---------- styles ---------- */
  var st = document.createElement('style');
  st.textContent =
    'img.htf-img{display:block;object-fit:fill;background:#fff}' +
    'img.htf-px{image-rendering:pixelated;image-rendering:crisp-edges}' +
    '.hte img.hte-fl{aspect-ratio:4/3;height:auto!important;outline:1px solid rgba(0,0,0,.35);outline-offset:-1px}' +
    '.vjc-chip.htf-chip{border-radius:0!important;background-size:cover!important;background-position:center!important;background-color:transparent!important;aspect-ratio:4/3;height:auto!important;border-color:rgba(0,0,0,.4)!important}';
  (document.head || document.documentElement).appendChild(st);

  window.HTFlag = { code: code, url: url, html: html, draw: draw, preload: preload, scan: scan, isNation: isNation };
  wrapCup();
  function boot() {
    wrapCup(); scan();
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j]; if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('img.htf-img')) scan(n.parentNode); else if (n.querySelector && n.querySelector('img.htf-img')) scan(n);
        if (n.closest && (n.closest('.vjc-sb') || n.closest('.vjc-vs') || (n.querySelector && n.querySelector('.vjc-chip')))) board(n.closest('.vjc-ui') || n);
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
